import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_FEEDER_SERVICE_EMPTY_DEPO_LIST:
      return { ...action.emptyDepoList };
    default:
      return state;
  }
};
